export default __webpack_public_path__ + "static/media/Cloudxier-ABIL-Profile-Developer.d72f6581.png";